import Logo from "../sampanganimation/assets/img/kominfo-logo.png"

export default function LoadingPage() {
    return (
        <>
        <style>{`
            @keyframes bounce {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-20px); }
            }
            .animate-bounce {
            animation: bounce 1s infinite;
            }
        `}</style>
        <div class="d-flex align-items-center justify-content-center vh-100 vw-100 bg-light">
            <div class="w-25 w-md-10 text-center">
                <img className="animate-bounce" src={Logo} alt="loading" width={120}/>
            </div>
        </div>
        </>
    )
}